import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import { GET_ADMINS, UPDATE_ACCOUNTANT } from "../../../api/apiAdmin";
import InputField from "../../atoms/InputField";
import Button from "../../atoms/Button";

const ModalEditAccountant = ({ accountant, onClose, refetch}) => {
    const [admins, setAdmins] = useState();

    useEffect(() => { 
        const getData = async () => {
            try {
                const admins = await GET_ADMINS();
                const filterAdmins = admins.filter(admin => !admin.isSuperAdmin)
                setAdmins(filterAdmins);
            } catch (error) {
                console.error(error);
            } 
        };
        getData();
    }, []);

    const optionsAdmins = admins?.map((admin) => ({ 
        label: admin?.name, 
        value: admin?.id, 
    }));

    const validate = (values) => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!values.name) { errors.name = "El nombre es requerido"; }
        if (!values.email) { errors.email = "El email es requerido"; } 
            else if (!emailRegex.test(values.email)) { errors.email = "El email no es válido"; }
        return errors;
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const upperCaseValues = {
                ...values,
                name: values.name.toUpperCase(),
            };
            await UPDATE_ACCOUNTANT(accountant.id ,upperCaseValues);
            toast.success("Cambio exitoso");
            refetch();
            onClose();
        } catch(error) {
            console.error(error);
            toast.error("Error al registrar");
        } finally {
            setSubmitting(false);
        }
    };

    const initialValues = { 
        name: accountant.name || "", 
        cellphone: accountant.cellphone || "",
        email: accountant.user.email || "", 
        password: "",
        adminId: accountant?.adminId
    };

    return(
        <div>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validate={validate}
            >
                {({ isSubmitting }) => (
                    <Form className="w-full flex flex-col items-center justify-center gap-4">
                        <div className="w-full grid grid-cols-1 md:grid-cols-2 items-center justify-center gap-4">
                            <InputField name="name" label="Nombre completo" placeholder="Nombre completo" capitalize />
                            <InputField name="cellphone" label="Teléfono" placeholder="Número de teléfono" capitalize type="number" />
                            <InputField name="email" label="Correo electrónico" placeholder="CORREO ELECTRÓNICO" />
                            <InputField name="password" label="Contraseña" type="password" placeholder="CONTRASEÑA" />
                            <InputField name="adminId" label="Supervisor" type="select" options={optionsAdmins} />
                        </div>
                        <Button text={isSubmitting ? <PropagateLoader color="red" /> : "Actualizar"} type="submit" disabled={isSubmitting} bgColor="blue" />
                    </Form>
                )}
            </Formik>
        </div>
    )
};

export default ModalEditAccountant;